const resList = [
                  {
                    "info": {
                      "id": "486966",
                      "name": "Annapurna Bhojanalya",
                      "cloudinaryImageId": "fnxxohtkdy4ke4nrz76w",
                      "locality": "RDC",
                      "areaName": "Raj Nagar",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Indian"
                      ],
                      "avgRating": 3.8,
                      "veg": true,
                      "feeDetails": {
                        "restaurantId": "486966",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 5600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 5600
                      },
                      "parentId": "34010",
                      "avgRatingString": "3.8",
                      "totalRatingsString": "500+",
                      "promoted": true,
                      "adTrackingId": "cid=7746463~p=3~eid=00000189-bd7e-d23f-0cfb-278d00850352~srvts=1691101352511~45826",
                      "sla": {
                        "deliveryTime": 30,
                        "lastMileTravel": 4.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30 mins",
                        "lastMileTravelString": "4.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 06:59:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "shortDescription": "options available",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "description": ""
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                        "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=486966",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "163817",
                      "name": "Rollsking",
                      "cloudinaryImageId": "y8hgfb41nsnnzwivqw16",
                      "locality": "Panchsheel Square Mall",
                      "areaName": "crossing republic",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "North Indian",
                        "Fast Food",
                        "Beverages"
                      ],
                      "avgRating": 3.6,
                      "feeDetails": {
                        "restaurantId": "163817",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 7600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 7600
                      },
                      "parentId": "4697",
                      "avgRatingString": "3.6",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 27,
                        "lastMileTravel": 6.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "27 mins",
                        "lastMileTravelString": "6.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 12:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          },
                          "textBased": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=163817",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "311388",
                      "name": "Burger Singh (Big Punjabi Burgers)",
                      "cloudinaryImageId": "kvkhhrtyayzhgkdixi0k",
                      "locality": "RDC Concrete (India) Pvt Ltd",
                      "areaName": "Raj Nagar",
                      "costForTwo": "₹300 for two",
                      "cuisines": [
                        "Snacks",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4.1,
                      "feeDetails": {
                        "restaurantId": "311388",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 5600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 5600
                      },
                      "parentId": "375065",
                      "avgRatingString": "4.1",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 27,
                        "lastMileTravel": 4.9,
                        "serviceability": "SERVICEABLE",
                        "slaString": "27 mins",
                        "lastMileTravelString": "4.9 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 04:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          },
                          "textBased": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                        "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=311388",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "395550",
                      "name": "The Meal Factory",
                      "cloudinaryImageId": "zkc9c5bymqgvw79naf94",
                      "locality": "Panchsheel Square Mall",
                      "areaName": "crossing republic",
                      "costForTwo": "₹150 for two",
                      "cuisines": [
                        "North Indian",
                        "Chinese"
                      ],
                      "avgRating": 3.5,
                      "veg": true,
                      "feeDetails": {
                        "restaurantId": "395550",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 7600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 7600
                      },
                      "parentId": "10914",
                      "avgRatingString": "3.5",
                      "totalRatingsString": "100+",
                      "promoted": true,
                      "adTrackingId": "cid=7746293~p=4~eid=00000189-bd7e-d23f-0cfb-278e00850407~srvts=1691101352511~45826",
                      "sla": {
                        "deliveryTime": 37,
                        "lastMileTravel": 6.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "37 mins",
                        "lastMileTravelString": "6.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "shortDescription": "options available",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                        "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=395550",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "626553",
                      "name": "La Pino'z Pizza",
                      "cloudinaryImageId": "mkbgksj3ou3gsc7znsdd",
                      "locality": "sector 10",
                      "areaName": "Raj Nagar",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Pizzas",
                        "Pastas",
                        "Italian",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 3.7,
                      "feeDetails": {
                        "restaurantId": "626553",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 5600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 5600
                      },
                      "parentId": "4961",
                      "avgRatingString": "3.7",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 28,
                        "lastMileTravel": 4.9,
                        "serviceability": "SERVICEABLE",
                        "slaString": "28 mins",
                        "lastMileTravelString": "4.9 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 04:30:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          },
                          "textBased": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "60% OFF",
                        "subHeader": "UPTO ₹120"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=626553",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "57686",
                      "name": "Subway",
                      "cloudinaryImageId": "1ace5fa65eff3e1223feb696c956b38b",
                      "locality": "Saviour Mall",
                      "areaName": "La Gracia Mall",
                      "costForTwo": "₹350 for two",
                      "cuisines": [
                        "Salads",
                        "Snacks",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 3.4,
                      "feeDetails": {
                        "restaurantId": "57686",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 7600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 7600
                      },
                      "parentId": "2",
                      "avgRatingString": "3.4",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 27,
                        "lastMileTravel": 6.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "27 mins",
                        "lastMileTravelString": "6.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 07:50:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=57686",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "306919",
                      "name": "Ghar ka tadka",
                      "cloudinaryImageId": "zoi1spzrb0htmaxzcckb",
                      "locality": "sector 10",
                      "areaName": "Raj Nagar",
                      "costForTwo": "₹150 for two",
                      "cuisines": [
                        "Indian",
                        "North Indian",
                        "Chinese",
                        "Home Food"
                      ],
                      "avgRating": 3.6,
                      "veg": true,
                      "feeDetails": {
                        "restaurantId": "306919",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 5600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 5600
                      },
                      "parentId": "8838",
                      "avgRatingString": "3.6",
                      "totalRatingsString": "500+",
                      "promoted": true,
                      "adTrackingId": "cid=7746290~p=8~eid=00000189-bd7e-d23f-0cfb-279200850840~srvts=1691101352511~45826",
                      "sla": {
                        "deliveryTime": 30,
                        "lastMileTravel": 4.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30 mins",
                        "lastMileTravelString": "4.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 12:00:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "shortDescription": "options available",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "description": ""
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "60% OFF",
                        "subHeader": "UPTO ₹120"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=306919",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "712135",
                      "name": "Goli Vada Pav No.1",
                      "cloudinaryImageId": "5bd0f232897bb15eae923593adcf80b4",
                      "locality": "Panchsheel",
                      "areaName": "Crossing Republic",
                      "costForTwo": "₹200 for two",
                      "cuisines": [
                        "Snacks"
                      ],
                      "avgRating": 3.8,
                      "feeDetails": {
                        "restaurantId": "712135",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 7600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 7600
                      },
                      "parentId": "3998",
                      "avgRatingString": "3.8",
                      "totalRatingsString": "50+",
                      "sla": {
                        "deliveryTime": 29,
                        "lastMileTravel": 6.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "29 mins",
                        "lastMileTravelString": "6.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 23:55:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "isNewlyOnboarded": true,
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=712135",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "549819",
                      "name": "Biryani Blues",
                      "cloudinaryImageId": "sludnbblldmevxug95kt",
                      "locality": "Rakesh Marg",
                      "areaName": "Nehru Nagar",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Biryani",
                        "Hyderabadi",
                        "Lucknowi",
                        "Kebabs",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4.3,
                      "feeDetails": {
                        "restaurantId": "549819",
                        "fees": [
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 6600
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 6600
                      },
                      "parentId": "13813",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 26,
                        "lastMileTravel": 5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "26 mins",
                        "lastMileTravelString": "5.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 04:00:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "shortDescription": "options available",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                        "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=549819",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "393206",
                      "name": "The Urban Dhaba",
                      "cloudinaryImageId": "bl7jnqqltreqermbsih7",
                      "locality": "Panchsheel Square Mall",
                      "areaName": "Nai Basti Dundahera",
                      "costForTwo": "₹150 for two",
                      "cuisines": [
                        "North Indian"
                      ],
                      "avgRating": 3.7,
                      "veg": true,
                      "feeDetails": {
                        "restaurantId": "393206",
                        "fees": [
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 7600
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 7600
                      },
                      "parentId": "8749",
                      "avgRatingString": "3.7",
                      "totalRatingsString": "100+",
                      "promoted": true,
                      "adTrackingId": "cid=7746286~p=9~eid=00000189-bd7e-d23f-0cfb-27930085091e~srvts=1691101352511~45826",
                      "sla": {
                        "deliveryTime": 38,
                        "lastMileTravel": 6.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "38 mins",
                        "lastMileTravelString": "6.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "description": "",
                                  "shortDescription": "options available",
                                  "fontColor": "#7E808C"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                        "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=393206",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "346573",
                      "name": "Apni Veg Rasoi",
                      "cloudinaryImageId": "oimdnn8q65veuj9d3vx6",
                      "locality": "RDC Concrete (India) Pvt Ltd",
                      "areaName": "Raj Nagar",
                      "costForTwo": "₹150 for two",
                      "cuisines": [
                        "North Indian",
                        "Chinese"
                      ],
                      "avgRating": 3.8,
                      "veg": true,
                      "feeDetails": {
                        "restaurantId": "346573",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 5600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 5600
                      },
                      "parentId": "22092",
                      "avgRatingString": "3.8",
                      "totalRatingsString": "500+",
                      "sla": {
                        "deliveryTime": 30,
                        "lastMileTravel": 4.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30 mins",
                        "lastMileTravelString": "4.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 06:59:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "shortDescription": "options available",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "description": ""
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                        "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=346573",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "62686",
                      "name": "The Pizza Cafe",
                      "cloudinaryImageId": "i5oohkmwdu81k45yqz89",
                      "locality": "Crossing Republik",
                      "areaName": "Shastri Nagar",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Continental",
                        "Italian"
                      ],
                      "avgRating": 3.5,
                      "veg": true,
                      "feeDetails": {
                        "restaurantId": "62686",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 4800
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 4800
                      },
                      "parentId": "15353",
                      "avgRatingString": "3.5",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 25,
                        "lastMileTravel": 3.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25 mins",
                        "lastMileTravelString": "3.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 04:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textExtendedBadges": {
                            
                          },
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                        "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=62686",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "231462",
                      "name": "Mr. Hungry",
                      "cloudinaryImageId": "cnt2wxgqixgze1zu3u6s",
                      "locality": "sector 10",
                      "areaName": "Raj Nagar",
                      "costForTwo": "₹150 for two",
                      "cuisines": [
                        "North Indian",
                        "Indian",
                        "Asian",
                        "Chinese",
                        "Snacks",
                        "Thalis"
                      ],
                      "avgRating": 3.6,
                      "veg": true,
                      "feeDetails": {
                        "restaurantId": "231462",
                        "fees": [
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 5600
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 5600
                      },
                      "parentId": "387768",
                      "avgRatingString": "3.6",
                      "totalRatingsString": "1K+",
                      "promoted": true,
                      "adTrackingId": "cid=7746291~p=10~eid=00000189-bd7e-d23f-0cfb-279400850a08~srvts=1691101352511~45826",
                      "sla": {
                        "deliveryTime": 32,
                        "lastMileTravel": 4.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "32 mins",
                        "lastMileTravelString": "4.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 06:59:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=231462",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "333500",
                      "name": "Pizzalicious",
                      "cloudinaryImageId": "cl4nbhtzavj6nw8s3i1d",
                      "locality": "A Block",
                      "areaName": "Shastri Nagar",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Continental",
                        "Italian"
                      ],
                      "avgRating": 3.4,
                      "veg": true,
                      "feeDetails": {
                        "restaurantId": "333500",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 4800
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 4800
                      },
                      "parentId": "4204",
                      "avgRatingString": "3.4",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 27,
                        "lastMileTravel": 3.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "27 mins",
                        "lastMileTravelString": "3.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 04:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=333500",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "333498",
                      "name": "Pizza Plus",
                      "cloudinaryImageId": "tlth5ulwbhyfhegkeba0",
                      "locality": "A Block",
                      "areaName": "Raj Nagar",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Continental",
                        "Italian"
                      ],
                      "avgRating": 3.2,
                      "feeDetails": {
                        "restaurantId": "333498",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 4800
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 4800
                      },
                      "parentId": "14111",
                      "avgRatingString": "3.2",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 26,
                        "lastMileTravel": 3.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "26 mins",
                        "lastMileTravelString": "3.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 04:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                        "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=333498",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "393210",
                      "name": "Second Wife Restaurant",
                      "cloudinaryImageId": "ptj4nzbtupyzljeil8tu",
                      "locality": "Panchsheel Square Mall",
                      "areaName": "crossing republic",
                      "costForTwo": "₹150 for two",
                      "cuisines": [
                        "North Indian"
                      ],
                      "avgRating": 3.8,
                      "veg": true,
                      "feeDetails": {
                        "restaurantId": "393210",
                        "fees": [
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 7600
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 7600
                      },
                      "parentId": "13721",
                      "avgRatingString": "3.8",
                      "totalRatingsString": "100+",
                      "promoted": true,
                      "adTrackingId": "cid=7746298~p=11~eid=00000189-bd7e-d23f-0cfb-279500850b40~srvts=1691101352511~45826",
                      "sla": {
                        "deliveryTime": 36,
                        "lastMileTravel": 6.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "36 mins",
                        "lastMileTravelString": "6.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                        "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=393210",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "333510",
                      "name": "Pizza Studio",
                      "cloudinaryImageId": "v1yqxlovkmz0v4kjodoh",
                      "locality": "A Block",
                      "areaName": "Shastri Nagar",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Continental",
                        "Italian"
                      ],
                      "avgRating": 3.1,
                      "feeDetails": {
                        "restaurantId": "333510",
                        "fees": [
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 4800
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 4800
                      },
                      "parentId": "8628",
                      "avgRatingString": "3.1",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 29,
                        "lastMileTravel": 3.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "29 mins",
                        "lastMileTravelString": "3.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 04:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textExtendedBadges": {
                            
                          },
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "60% OFF",
                        "subHeader": "UPTO ₹120"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=333510",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "75230",
                      "name": "Chawla's Tandoori Junction",
                      "cloudinaryImageId": "vdgdk2ploooihjebtcxs",
                      "locality": "RDC Concrete (India) Pvt Ltd",
                      "areaName": "Raj Nagar",
                      "costForTwo": "₹500 for two",
                      "cuisines": [
                        "Chinese",
                        "North Indian"
                      ],
                      "avgRating": 3.9,
                      "feeDetails": {
                        "restaurantId": "75230",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 6600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 6600
                      },
                      "parentId": "58971",
                      "avgRatingString": "3.9",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 36,
                        "lastMileTravel": 5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "36 mins",
                        "lastMileTravelString": "5.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 04:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "30% OFF",
                        "subHeader": "UPTO ₹75"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=75230",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "464100",
                      "name": "Glocal Bhoj",
                      "cloudinaryImageId": "lwocw3p3m31lcjprwges",
                      "locality": "Panchsheel Square Mall\n",
                      "areaName": "crossing republic",
                      "costForTwo": "₹150 for two",
                      "cuisines": [
                        "Indian"
                      ],
                      "avgRating": 3.7,
                      "veg": true,
                      "feeDetails": {
                        "restaurantId": "464100",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 7600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 7600
                      },
                      "parentId": "11987",
                      "avgRatingString": "3.7",
                      "totalRatingsString": "100+",
                      "promoted": true,
                      "adTrackingId": "cid=7746273~p=12~eid=00000189-bd7e-d23f-0cfb-279600850c5e~srvts=1691101352511~45826",
                      "sla": {
                        "deliveryTime": 37,
                        "lastMileTravel": 6.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "37 mins",
                        "lastMileTravelString": "6.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textExtendedBadges": {
                            
                          },
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                        "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=464100",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "736179",
                      "name": "Olio - The Wood Fired Pizzeria",
                      "cloudinaryImageId": "4b44c7921b1b6073a4ffa58b38f8def1",
                      "locality": "Gautam Buddha Nagar",
                      "areaName": "Shahberi",
                      "costForTwo": "₹300 for two",
                      "cuisines": [
                        "Pizzas",
                        "Pastas",
                        "Fast Food",
                        "Snacks",
                        "Beverages"
                      ],
                      "avgRating": 4.4,
                      "feeDetails": {
                        "restaurantId": "736179",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 7600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 7600
                      },
                      "parentId": "11633",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "20+",
                      "sla": {
                        "deliveryTime": 35,
                        "lastMileTravel": 6.9,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35 mins",
                        "lastMileTravelString": "6.9 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 05:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "newg.png",
                            "description": "Gourmet"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "imageId": "newg.png",
                                  "description": "Gourmet"
                                }
                              }
                            ]
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "isNewlyOnboarded": true,
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=736179",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "376533",
                      "name": "Veg Potli",
                      "cloudinaryImageId": "nu921709bssfqaolhing",
                      "locality": "RDC Concrete (India) Pvt Ltd",
                      "areaName": "Raj Nagar",
                      "costForTwo": "₹150 for two",
                      "cuisines": [
                        "Indian"
                      ],
                      "avgRating": 3.8,
                      "veg": true,
                      "feeDetails": {
                        "restaurantId": "376533",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 5600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 5600
                      },
                      "parentId": "21992",
                      "avgRatingString": "3.8",
                      "totalRatingsString": "100+",
                      "promoted": true,
                      "adTrackingId": "cid=7746303~p=13~eid=00000189-bd7e-d23f-0cfb-279700850d03~srvts=1691101352511~45826",
                      "sla": {
                        "deliveryTime": 32,
                        "lastMileTravel": 4.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "32 mins",
                        "lastMileTravelString": "4.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 06:59:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "headerTypeV2": "HEADER_TYPE_V2_TOP_UP",
                        "secondaryDiscountCallout": "+ EXTRA ₹75 OFF"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=376533",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "553993",
                      "name": "The Brooklyn Creamery - Healthy Ice Cream",
                      "cloudinaryImageId": "b1b35780a9b1dfeb26d680506d494eaa",
                      "locality": "Panchsheel Square Mall",
                      "areaName": "crossing republic",
                      "costForTwo": "₹200 for two",
                      "cuisines": [
                        "Desserts",
                        "Ice Cream",
                        "Healthy Food"
                      ],
                      "avgRating": 4,
                      "feeDetails": {
                        "restaurantId": "553993",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 7600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 7600
                      },
                      "parentId": "236673",
                      "avgRatingString": "4.0",
                      "totalRatingsString": "20+",
                      "sla": {
                        "deliveryTime": 33,
                        "lastMileTravel": 6.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "33 mins",
                        "lastMileTravelString": "6.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-11 00:00:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "brand",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "shortDescription": "brand",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "description": ""
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "60% OFF",
                        "subHeader": "UPTO ₹120"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=553993",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "200747",
                      "name": "Veer Ji Malai Chaap Wale",
                      "cloudinaryImageId": "ot55vxhy3ng0eocbwlqb",
                      "locality": "Panchsheel Square Mall",
                      "areaName": "crossing republic",
                      "costForTwo": "₹200 for two",
                      "cuisines": [
                        "North Indian"
                      ],
                      "avgRating": 3.6,
                      "feeDetails": {
                        "restaurantId": "200747",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 7600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 7600
                      },
                      "parentId": "12056",
                      "avgRatingString": "3.6",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 31,
                        "lastMileTravel": 6.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "31 mins",
                        "lastMileTravelString": "6.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 04:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=200747",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "736180",
                      "name": "Crusto's - Cheese Burst Pizza",
                      "cloudinaryImageId": "2e7493543bd1785e8196144625a5b20b",
                      "locality": "Gautam Buddha Nagar",
                      "areaName": "Shahberi",
                      "costForTwo": "₹300 for two",
                      "cuisines": [
                        "Pizzas",
                        "Pastas",
                        "Fast Food",
                        "Snacks",
                        "Beverages"
                      ],
                      "avgRating": 5,
                      "feeDetails": {
                        "restaurantId": "736180",
                        "fees": [
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 7600
                          },
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 7600
                      },
                      "parentId": "268955",
                      "avgRatingString": "5.0",
                      "totalRatingsString": "20+",
                      "sla": {
                        "deliveryTime": 32,
                        "lastMileTravel": 6.9,
                        "serviceability": "SERVICEABLE",
                        "slaString": "32 mins",
                        "lastMileTravelString": "6.9 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 05:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "isNewlyOnboarded": true,
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=736180",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "516337",
                      "name": "Samosa Party",
                      "cloudinaryImageId": "eywohwrrwky4rqmeyc3f",
                      "locality": "High Street",
                      "areaName": "crossing republic",
                      "costForTwo": "₹150 for two",
                      "cuisines": [
                        "Fast Food",
                        "Snacks",
                        "Beverages",
                        "Chaat",
                        "North Indian",
                        "Street Food",
                        "Sweets",
                        "Desserts",
                        "Punjabi",
                        "Bakery"
                      ],
                      "avgRating": 4.1,
                      "feeDetails": {
                        "restaurantId": "516337",
                        "fees": [
                          {
                            "name": "BASE_TIME"
                          },
                          {
                            "name": "BASE_DISTANCE",
                            "fee": 7600
                          },
                          {
                            "name": "ANCILLARY_SURGE_FEE"
                          }
                        ],
                        "totalFee": 7600
                      },
                      "parentId": "6364",
                      "avgRatingString": "4.1",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 26,
                        "lastMileTravel": 6.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "26 mins",
                        "lastMileTravelString": "6.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-08-04 05:59:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "shortDescription": "options available",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "description": ""
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "imageBased": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "10% OFF",
                        "subHeader": "UPTO ₹40"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "swiggy://menu?restaurant_id=516337",
                      "text": "RESTAURANT_MENU",
                      "type": "DEEPLINK"
                    }
                  }
                ];
export default resList;